module.exports = __webpack_public_path__ + "img/eu-input.618ae19.jpg";